/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';

import { Box, Grid } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import Spinner from 'modules/common/spinner.component';
import GoodsShipmentEstimates from './goodsShipmentEstimates.component';
import { updateHhgEstimate } from 'modules/authorizations/store/actions/houseHoldGoods.actions';
import GoodsShipmentMovingDatesCard from './goodsShipmentMovingDates.component';
import RequestDetailsEstimatesCard from './requestDetailsEstimatesCard.component';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { SERVICE_IDS } from 'modules/enumerations/enumerationIds';
import AuthServiceGlobalEmailCardComponent from 'modules/emailTemplates/authEmailTemplates/authServiceGlobalEmailCard.component';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});

const EstimatesActuals = props => {
  const {
    details,
    estimateId,
    location,
    isLoadingEstimates,
    segmentId,
    isReadOnly,
    id,
    emailTemplates,
    vendors,
    history,
    authCommentServiceTypes,
    authCommentRegardingTypes
   } = props;

  const segmentInfo = details.hhgSegments ? details.hhgSegments.find(s => s.segmentInfo.hhgSegmentId === segmentId) : null;

  var vendorId = segmentInfo?.segmentInfo?.vendorId;
  const hhgSegmentTemplates = emailTemplates.filter(t => isIdEqual(t.serviceId, SERVICE_IDS.HHG_SERVICE_ID) && t.containsHHG);

  const estimateInfo =
    segmentInfo && segmentInfo.estimates.find(e => e.estimateInfo.hhgEstimateId === estimateId)
      ? segmentInfo.estimates.find(e => e.estimateInfo.hhgEstimateId === estimateId)
      : null;

  const isReadOnlyMode = location.pathname.includes('expenses') || isReadOnly;

  let vendorOptions = [];
  if (vendorId) {
    const vendorIdSet = new Set([vendorId]);
    vendorOptions = Array.from(vendorIdSet)
      .map(vendorId => {
        const v = (vendors || []).find(x => x.vendorId === vendorId);
        if (!v?.officeEmail || !v?.companyName) return null;

        return {
          vendorId: vendorId,
          officeEmail: v.officeEmail,
          companyName: v.companyName
        };
      })
      .filter(Boolean);
  }

  return (
    <Box>
      {!estimateInfo && !isLoadingEstimates && (
        <Box sx={{ padding: '20px', fontSize: '20px' }}>
          <b>No estimate selected. Create a new estimate above to get started.</b>
        </Box>
      )}
      {estimateInfo && !isLoadingEstimates && (
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} xl={8} rowSpacing={2}>
            <RequestDetailsEstimatesCard estimate={estimateInfo} hideEdit={isReadOnlyMode} authId={id} />
            <Box sx={{ paddingTop: '16px' }}>
              <GoodsShipmentMovingDatesCard estimateId={estimateId} estimateInfo={estimateInfo} authId={id} hideEdit={isReadOnlyMode} />
            </Box>
          </Grid>
          <Grid item xs={12} xl={4} rowSpacing={2}>
            <AuthServiceGlobalEmailCardComponent
              authId={id}
              communication={details.authorizationDetails}
              serviceTemplates={hhgSegmentTemplates}
              serviceId={SERVICE_IDS.HHG_SERVICE_ID}
              authCommentServicesEnum={authCommentServiceTypes}
              authCommentRegardingEnum={authCommentRegardingTypes}
              authSentTemplates={details.sentEmailTemplates}
              history={history}
              selectedAuthServiceId={segmentId}
              vendorOptions={vendorOptions}
              allVendorOptions={vendors}
              selectedSegmentServiceId={estimateId}
              selectedVendorId={vendorId}
              emailTemplates={emailTemplates}
              isReadOnly={isReadOnly}
            />
            <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '16px' }}>
              <GoodsShipmentEstimates estimate={estimateInfo} hideEdit={isReadOnlyMode} authId={id} />
            </Box>
          </Grid>
        </Grid>
      )}
      {isLoadingEstimates && <Spinner />}
    </Box>
  );
};

EstimatesActuals.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {};
};

export default compose(withStyles(styles), connect(mapStateToProps, { updateHhgEstimate }))(EstimatesActuals);
